"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationOutcome = void 0;
/**
 * A collection of error, warning, or information messages that result from a system action.
 */
var OperationOutcome = /** @class */ (function () {
    function OperationOutcome() {
    }
    return OperationOutcome;
}());
exports.OperationOutcome = OperationOutcome;
